import { AuthService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";
import initService from "@/services/modules/initService";
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");
export default {
  name: "password-reset",
  components: { Captcha },
  props: [],
  data() {
    return {
      // rules: {
      //   required: value => !!value || "وارد کردن این فیلد الزامی است."
      //   // min: v => v.length >= 8 || "Min 8 characters",
      //   // emailMatch: () => `The email and password you entered don't match`
      // },
      loading: false,
      show1: false,
      show2: false,
      password: "",
      passwordValidation: [
        () =>
          !!this.password ||
          this.$t("authPage.passwordResetPage.password.validation.notEmpty"),
        v =>
          !/^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
            v.replace(/\s/g, "")
          ) ||
          this.$t("authPage.passwordResetPage.password.validation.notPersian")
      ],
      passwordConfirmation: "",
      recaptcha_token: "",
      validationRegex: [],
      matchedCase: [],
      validationMessage: "",
      regexErrors: [],
      isFocused: false,
      isBlurred: false,
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      captchaStatus: false
    };
  },
  computed: {
    optToken() {
      return localStorage.getItem("otpToken");
    }
  },
  mounted() {
    this.getPasswordRegex();
    this.getCaptchaStatus();
  },
  methods: {
    ...mapActions({
      setValidationRegex: types.auth.actions.ACTION_VALIDATION_REGEX
    }),
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.users_password_reset;
      });
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    onSubmit() {
      this.loading = true;
      AuthService.resetPassword(
        this.optToken,
        this.password,
        this.passwordConfirmation,
        this.captcha_token,
        this.captcha_value
      )
        .then(response => {
          localStorage.removeItem("otpToken");
          this.$toast.success(response.data.data.message);
          setTimeout(() => {
            this.$router.push("/auth/login");
          }, 5000);
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
          if (error.data.code === "otp_token_is_expired") {
            this.$router.push({ name: "passwordRecovery" });
          }
        })
        .finally(() => {
          this.loading = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },
    getPasswordRegex() {
      AuthService.passwordRegex()
        .then(response => {
          this.validationRegex = response.data.data;
        })
        .then(() => {
          this.validationRegex.forEach(elem => {
            let regex = elem.regex;
            regex = regex.substring(1, regex.length - 1);
            this.matchedCase.push({
              message: elem.message,
              type: elem.type,
              regex: regex,
              status: "default"
            });
          });
          this.setValidationRegex(this.matchedCase);
        });
    },
    validatePassword(value) {
      this.regexErrors = [];
      this.matchedCase.forEach(elem => {
        if (value.match(elem.regex)) {
          if (this.isFocused) {
            elem.status = "checked";
          }
          this.regexErrors.push(elem);
        } else {
          if (this.isBlurred) {
            elem.status = "unchecked";
          } else if (this.isFocused) {
            elem.status = "default";
          }
          this.regexErrors.push(elem);
        }
      });
    },
    reInitValidation(event) {
      if (event.type === "focus") {
        this.isFocused = true;
        this.regexErrors = [...this.matchedCase];
      } else if (event.type === "blur") {
        this.isBlurred = true;
        this.validatePassword(this.password);
      }
    }
  }
};
